/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomAssetLifecycleColumn
 */
export interface CustomAssetLifecycleColumn {
    /**
     * 
     * @type {string}
     * @memberof CustomAssetLifecycleColumn
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssetLifecycleColumn
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssetLifecycleColumn
     */
    columnType: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssetLifecycleColumn
     */
    parentId?: string;
}

/**
 * Check if a given object implements the CustomAssetLifecycleColumn interface.
 */
export function instanceOfCustomAssetLifecycleColumn(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "columnType" in value;

    return isInstance;
}

export function CustomAssetLifecycleColumnFromJSON(json: any): CustomAssetLifecycleColumn {
    return CustomAssetLifecycleColumnFromJSONTyped(json, false);
}

export function CustomAssetLifecycleColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAssetLifecycleColumn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'role': json['role'],
        'columnType': json['column_type'],
        'parentId': !exists(json, 'parent_id') ? undefined : json['parent_id'],
    };
}

export function CustomAssetLifecycleColumnToJSON(value?: CustomAssetLifecycleColumn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'role': value.role,
        'column_type': value.columnType,
        'parent_id': value.parentId,
    };
}

